import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-800" }
const _hoisted_2 = { class: "mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:py-40 lg:px-8" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold leading-10 tracking-tight text-white" }, " Domande Frequenti ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 max-w-2xl text-base leading-7 text-gray-500" }, [
  /*#__PURE__*/_createTextVNode(" Hai una domanda diversa e non riesci a trovare la risposta che stai cercando? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Contatta il nostro team di supporto "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:info@diamondsconsulting.it ",
    class: "hover:text-indigo-30 font-semibold text-accent-100"
  }, "inviandoci un'e-mail "),
  /*#__PURE__*/_createTextVNode(" e ti risponderemo il prima possibile. ")
], -1)
const _hoisted_6 = { class: "mt-10 space-y-6 divide-y divide-white/10" }
const _hoisted_7 = { class: "text-base font-semibold leading-7" }
const _hoisted_8 = { class: "ml-6 flex h-7 items-center" }
const _hoisted_9 = { class: "text-base leading-7 text-gray-500" }

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'FAQ',
  setup(__props) {

const faqs = [
	{
		question:
			"Le recensioni dai servizi vengono sincronizzate automaticamente?",
		answer:
			"Si, le recensioni vengono sincronizzate automaticamente, non é necessario alcun intervento da parte tua. Significa che automaticamente i grafici cambieranno in base alle recensioni che verranno inserite dai tuoi clienti su Booking, Expedia, TripAdvisor, Google senza il tuo intervento.",
	},
	{
		question:
			"Le recensioni dei competitor vengono sincronizzate automaticamente?",
		answer:
			"Si, le recensioni dei competitor vengono sincronizzate automaticamente, non é necessario alcun intervento da parte tua.",
	},
	{
		question: "Riceveró aggiornamenti automatici?",
		answer:
			"Si, l'applicazione é in continua evoluzione e verranno aggiunti nuovi servizi e funzionalitá senza alcun costo aggiuntivo.",
	},
	{
		question: "L'applicazione é disponibile anche in diverse lingue?",
		answer:
			"Si, l'applicazione é disponibile in italiano, inglese, francese, tedesco, spagnolo, portoghese, russo per garantire la completa comprensione agli ospiti della tua struttura",
	},
	{
		question: "L'applicazione é disponibile per tutti i dispositivi?",
		answer:
			"Si, l'applicazione é disponibile per tutti i dispositivi, sia desktop che tablet che mobile.",
	},
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("dl", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(faqs, (faq) => {
            return _createVNode(_unref(Disclosure), {
              as: "div",
              key: faq.question,
              class: "pt-6"
            }, {
              default: _withCtx(({ open }) => [
                _createElementVNode("dt", null, [
                  _createVNode(_unref(DisclosureButton), { class: "flex w-full items-start justify-between text-left text-white" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(faq.question), 1),
                      _createElementVNode("span", _hoisted_8, [
                        (!open)
                          ? (_openBlock(), _createBlock(_unref(MinusSmallIcon), {
                              key: 0,
                              class: "h-6 w-6",
                              "aria-hidden": "true"
                            }))
                          : (_openBlock(), _createBlock(_unref(PlusSmallIcon), {
                              key: 1,
                              class: "h-6 w-6",
                              "aria-hidden": "true"
                            }))
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createVNode(_unref(DisclosurePanel), {
                  as: "dd",
                  class: "mt-2 pr-12"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(faq.answer), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})